<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/Julibee_Logo.png')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
        class="logo-fjjilter"
      />

      <base-title
        size="body-1"
        space="4"
        title="Julibee Employment Pte Ltd"
        weight="regular"
      />

      <base-body>License No.: 23C1569</base-body>
      <base-btn class="mb-12" color="white" outlined href="/privacy-policy">
        Privacy Policy
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseInfo",

  props: {
    title: String,
    dark: Boolean
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text:
          "Julibee Employment Pte Ltd. <br>Blk 703 Bedok Reservoir Road, <br> #01-3510,<br> Singapore 470703"
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+65 9859 6645" < br > "+65 9784 9202"
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "julibeeemployment@gmail.com"
      }
    ]
  })
};
</script>

<style scoped>
.logo-filter {
  filter: grayscale(100%);
}
</style>
